import { Text } from '#app/components/Primitives/Text.js';
import { TextLink } from '#app/components/TextLink/TextLink.js';
import { css, styled } from 'styled-components';

const AccountDoesNotExistContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    border-top: 1px solid ${theme.colorsV2.black};
    padding-top: 40px;
    margin: 0;

    ${theme.mediaQueries.md} {
      margin: 128px 32px 0;
    }
  `}
`;

export const AccountDoesNotExist = ({
  currentUsername,
}: {
  readonly currentUsername?: string;
}) => {
  return (
    <AccountDoesNotExistContainer>
      <Text
        mb="24px"
        textStyle={{
          _: 'fifthLevelHeadline',
          md: 'fourthLevelHeadline',
        }}
      >
        This account doesn't exist
      </Text>
      {currentUsername && (
        <TextLink to={`/${currentUsername}`}>View Your Profile</TextLink>
      )}
    </AccountDoesNotExistContainer>
  );
};
